import { render, staticRenderFns } from "./AddOrUpdate.vue?vue&type=template&id=70d1cf8f&"
import script from "./AddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports